export default "__VITE_ASSET__CSlE2Aff__"